import { LeagueDto } from '../../../models/dtos/league.dto';
import axios from '../../axios';

export default async function getLeaguesRequest(): Promise<LeagueDto[]> {
  const response = await axios.get<LeagueDto[]>(
    `${process.env.REACT_APP_BASE_URL}/leagues`
  );
  return response.data;
}
